import React, {useState, useEffect, useRef} from 'react';
import {
  Link,
  useParams,
  useHistory
} from "react-router-dom";
import PersonForm from '../../components/PersonEditForm';
import {uploadFile} from '../../Utils.js';
import slugify from 'slugify';
import moment from 'moment';

export default function AccountPersonAdd({ showMessage, userId }) {
  const defaultPerson = {
    name: '',
    description: '',
    notes: '',
    comments: [],
    address: '',
    website: '',
    twitter: '',
    facebook: '',
    instagram: '',
    featureTypes: [],
    genres: [],
    outlets: [],
  };
  const [person, setPerson] = useState(defaultPerson);
  const [error, setError] = useState('');
  const [login, setLogin] = useState(false);

  let history = useHistory();

  document.title = 'Creating Person | Sublunary Admin';


  const submit = async () => {
    let data = await window.ASTERISM.makeRequest(`create-person?id=${userId}`, 'POST', person);
    if (data.ok) {
      showMessage({text: 'Person successfully created!', temp: true, type: 'success'});
      history.push(`/my-account/people/${data.id}`);
    }
  }

  if (error) {
    return (
      <div className='edit-bar'><div className='edit-title'>{error} {login && <Link to={`/login?return=${window.location.pathname}`}><button className='secondary-submit'>Login</button></Link>}</div></div>
    )
  }

  return (
    <div className=''>
      <div className='edit-bar'>
        <div className='edit-title'>Creating a New Person</div>
        <button className='main-submit' onClick={submit}>Create Person</button>
      </div>
      <PersonForm setPage={setPerson} page={person} />
    </div>
  )
}
